import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { isAPIErrorList, parseServerError } from "marvin-auth-kit";

export function useErrorSnackbar() {
  const { enqueueSnackbar } = useSnackbar();
  const {
    t,
    i18n: { exists: translationExists },
  } = useTranslation();

  function enqueueErrorSnackbar(errors: unknown) {
    if (isAPIErrorList(errors)) {
      errors.map((error) => {
        const message = translationExists(`message.${error.key}`)
          ? t(`message.${error.key}`, error.arguments)
          : parseServerError(error);
        return enqueueSnackbar(message, { variant: "error" });
      });
    } else {
      return enqueueSnackbar(t("label.somethingWentWrong"), {
        variant: "error",
      });
    }
  }
  return { enqueueErrorSnackbar };
}
